import { AwsUi } from '../../../core/runtime/src';
import { KeyCode } from '../../../core/utils/src/dom';
import { Input } from '../../input/src';
export default AwsUi.__addComponent('awsui-select-filter', {
    releaseStatus: 'internal',
    properties: {
        // The current filtering input value.
        value: {
            type: 'string'
        },
        // The placeholder displayed in the filtering input.
        placeholder: {
            type: 'string'
        },
        // Adds aria label on the built-in filtering input.
        label: {
            type: 'string'
        },
        // The currently highlighted option in the dropdown. The browser does not
        // consider it as an active element.
        highlightedOption: {
            type: 'object',
            objectType: 'Select.Option'
        },
        ariaLabelledby: {
            type: 'string'
        },
        ariaActivedescendant: {
            type: 'string'
        },
        ariaOwns: {
            type: 'string'
        },
        // Adds aria-required on the native input
        ariaRequired: {
            type: 'boolean'
        }
    },
    regions: {},
    functions: {
        __getFilteringInput: function () {
            return this.node.querySelector('.awsui-input');
        },
        blur: function () {
            this.__getFilteringInput().blur();
        },
        focus: function () {
            this.__getFilteringInput().focus();
        }
    },
    callbacks: {
        initialized: function () {
            // Prevent announcement of controlId so FormField won't pick it up
            this.node.addEventListener('awsui:__controlidchange', function (e) { return e.stopPropagation(); });
        }
    },
    render: function (m, h) {
        var _this = this;
        var getOptionText = function () {
            var option = _this.highlightedOption;
            if (!option) {
                return '';
            }
            return [
                option.label,
                option.labelTag || '',
                option.description || '',
                option.tags ? option.tags.join(' ') : '',
                option.filteringTags ? option.filteringTags.join(' ') : ''
            ].join(' ');
        };
        var onInputKeydown = function (event) {
            // prevent select filtering from accidental form submission
            if (event.detail.keyCode === KeyCode.enter) {
                event.preventDefault();
            }
        };
        return (AwsUi.__createElement("div", null,
            AwsUi.__createElement(Input, { className: "awsui-select-dropdown-filter", autocomplete: false, disableBrowserAutocorrect: true, label: this.label, value: this.value, placeholder: this.placeholder, type: "search", invalid: false, keydown: onInputKeydown, ariaDescribedby: null, ariaLabelledby: this.ariaLabelledby, ariaRequired: this.ariaRequired, __ariaActivedescendant: this.ariaActivedescendant, __ariaOwns: this.ariaOwns, __ariaExpanded: "true", __ariaHaspopup: "true", __role: "combobox", __nativeInputType: "text" })));
    }
});
//# sourceMappingURL=filter.js.map